import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  ListItemText,
  TextField,
} from '@material-ui/core';

const zoneTypes = ['', 'Numbers', 'Single letters', 'Double letters', 'Triple letters'];
const containerSpacing = 1;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const ITEM_INNER_PADDING = 4.5;
const PAPER_WIDTH = 250;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * ITEM_INNER_PADDING + ITEM_PADDING_TOP,
      width: PAPER_WIDTH,
    },
  },
};

function ZoneFilters({ classes, formValues, onChangeCallback, errorsFlags }) {
  return (
    <div style={{ marginBottom: 25 }}>
      {formValues.map((zone, index) => (
        <>
          <Grid container spacing={containerSpacing}>
            <Grid item xs={6}>
              {!index && (
                <InputLabel shrink className={classes.inputLabelZone}>
                  Zone
                </InputLabel>
              )}
              <Typography inline className={classes.typoAlignment}>
                <strong>{zone.zoneName}</strong>
              </Typography>
            </Grid>
            <Grid xs={6}>
              <FormControl>
                <InputLabel shrink htmlFor="zone_type">
                  Type
                </InputLabel>
                <Select
                  value={zone.type}
                  id={`${zone.zoneName}-type`}
                  name={`${zone.zoneName}-type`}
                  MenuProps={MenuProps}
                  onChange={onChangeCallback}
                  className={classes.fullWidth}
                >
                  {zoneTypes.map(name => (
                    <MenuItem key={name} value={name === '' ? null : name}>
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={containerSpacing}>
            <Grid item xs={6}>
              <TextField
                disabled={!zone.type}
                id={`${zone.zoneName}-low`}
                label="Low"
                onChange={onChangeCallback}
                name={`${zone.zoneName}-low`}
                value={zone.low}
                // onBlur={onBlurValidation}
                error={errorsFlags.includes(`${zone.zoneName}-low`)}
                helperText={
                  errorsFlags.includes(`${zone.zoneName}-low`) && 'Low format wrong, and should be lower than High.'
                }
                className={classes.inputTextMarginRight}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled={!zone.type}
                id={`${zone.zoneName}-high`}
                label="High"
                onChange={onChangeCallback}
                name={`${zone.zoneName}-high`}
                value={zone.high}
                // onBlur={onBlurValidation}
                error={errorsFlags.includes(`${zone.zoneName}-high`)}
                helperText={
                  errorsFlags.includes(`${zone.zoneName}-high`) && 'High format wrong, and should be greater than Low.'
                }
                className={classes.inputTextMarginRight}
              />
            </Grid>
          </Grid>
        </>
      ))}
    </div>
  );
}

ZoneFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  formValues: PropTypes.array.isRequired,
  errorsFlags: PropTypes.array.isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  // onBlurValidation: PropTypes.func.isRequired,
};

export default ZoneFilters;
